import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { RunAsUserDialogComponent } from 'src/cad/login/dialog/run-as-user.component';

@Component({
  selector: 'run-as-user-content',
  template: '',
})
export class RunAsUserContentComponent implements OnDestroy, OnInit {

  private dialogRef: MatDialogRef<RunAsUserDialogComponent>;
  private subscription: Subscription;

  constructor(
    private ngZone: NgZone,
    private dialog: MatDialog
  ) {}

  public ngOnInit(): void {
    setTimeout(() => {
      this.openDialog();
    }); // delay by one cycle to prevent ExpressionChangedAfterItHasBeenCheckedError error
  }

  public ngOnDestroy(): void {
    if (this.subscription) { this.subscription.unsubscribe(); }
    if (this.dialogRef) { this.dialogRef.close(); }
  }

  private openDialog(): void {
    this.ngZone.run(() => {
      this.dialogRef = this.dialog.open(RunAsUserDialogComponent, { disableClose: true, minWidth: 600 });
    });
  }
}
